import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { steps, PHONE_DISPLAY, PHONE_HREF } from '../data/content';
export function HowItWorks() {
  return <section id="how-it-works" className="w-full bg-white py-16 lg:py-24" data-id="element-139" data-mp="7u6kypox9mpz">
      <div className="mx-auto max-w-6xl px-5" data-id="element-140" data-mp="3pztabxs0gz7l">
        <p className="font-display text-sm uppercase tracking-[0.2em] text-ember-600" data-id="element-141" data-mp="3u03h3cnmntni">
          How it works
        </p>
        <h2 className="mt-2 font-display text-3xl uppercase text-forest-800 sm:text-4xl" data-id="element-142" data-mp="ljrwxg4b11oi">
          Call. Get your quote. We haul it away.
        </h2>

        <div className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-143" data-mp="qlh7yvrj1fcl">
          {steps.map((step, index) => <div key={step.title} className="flex h-full flex-col rounded-lg border border-forest-100 bg-forest-50 p-7" data-id="element-144" data-mp="crgeohjcgkjm" data-mpi={index}>
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-ember-500 font-display text-lg text-ink-900" data-id="element-145" data-mp="gr73wgt82sm1">
                {index + 1}
              </span>
              <h3 className="mt-5 font-display text-xl uppercase text-forest-800" data-id="element-146" data-mp="19b5ohjumst8f">{step.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-ink-700" data-id="element-147" data-mp="2rlxp13t4f055">{step.body}</p>
              {index === 0 && <a href={PHONE_HREF} className="mt-auto flex items-center gap-2 pt-5 font-display text-lg uppercase text-forest-800 underline decoration-ember-500 decoration-2 underline-offset-4 transition-colors duration-150 ease-out hover:text-ember-600" data-id="element-148" data-mp="2mki4dcuuuvna">
                  <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-149" data-mp="3ab4ct58ruhxt" />
                  {PHONE_DISPLAY}
                </a>}
            </div>)}
        </div>
      </div>
    </section>;
}